<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import Content from '@/domains/investor/components/Content/Content.vue'
import DividendHistoryTable from '@/domains/investor/components/DividendHistoryTable/DividendHistoryTable.vue'
import { useFetchTable } from '@/domains/investor/composables/useFetchTable'
import { useContent } from '@/domains/investor/composables/useContent'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorStockDividendPolicy.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorStockDividendPolicy.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorStockDividendPolicy.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorStockDividendPolicy.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorStockDividendPolicy.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorStockDividendPolicy.canonical.pl'),
    },
  ],
}))

const { getContent } = await useContent()
const { fetchTable } = await useFetchTable()
const policySection = await getContent('polityka-dywidendy')
const historicalFilesSection = await getContent('historyczne-pliki-dywidendowe')
const table = await fetchTable('history-dividend')
</script>

<template>
  <div class="investor-dividend-policy-page">

  <InvestorHero
      class="investor-dividend-policy-page__hero"
      :title="$t('investor.stock.dividendPolicy.title')"
      :lead="$t('investor.stock.dividendPolicy.description')"
      :main-category="{
        label: $t('investor.stock.dividendPolicy.mainCategory.label'),
        url: $t('investor.stock.dividendPolicy.mainCategory.url'),
      }"
      :second-category="{
        label: $t('investor.stock.dividendPolicy.secondCategory.label'),
        url: $t('investor.stock.dividendPolicy.secondCategory.url'),
      }"
      image="/images/investor/stock/dividend_policy.png"
      :first-button="{
        text: $t('investor.stock.dividendPolicy.firstButton.text'),
        to: `#${$t('investor.stock.dividendPolicy.policyId')}`
      }"
      :second-button="{
        text: $t('investor.stock.dividendPolicy.secondButton.text'),
        to: `#${$t('investor.stock.dividendPolicy.historyId')}`,
        variant: 'secondary'
      }"
    />

    <Content
      :id="$t('investor.stock.dividendPolicy.policyId')"
      :content="policySection.data.value?.content"
    />

    <DividendHistoryTable
      v-if="table.data.value"
      :id="$t('investor.stock.dividendPolicy.historyId')"
      :table="table.data.value"
      :options="{ highlightFirstColumn: true }"
    />
   
    <Content
      :content="historicalFilesSection.data.value?.content"
    />
  </div>
</template>
